export const TOKEN_NAME = 'alseco-pbp-token';
export const REFRESH_TOKEN_NAME = 'alseco-pbp-token-refresh';
export const COOKIE_KEY_LOCALE = 'org.springframework.web.servlet.i18n.CookieLocaleResolver.LOCALE';
export const LOCALE_STORE_NAME = 'alseco-pbp-locale';

// кол-во записей в результате поиска адресов
export const ADDRESSES_SEARCH_RESULT_SIZE = 9;
// кол-во столбцов для отображения результата
export const ADDRESSES_SEARCH_RESULT_COLUMNS = 3;

export const RECAPTCHA_SITE_KEY = '6LcnPqssAAAAAG5qOXaoSPLW3GCubBszBjf_ZZ3U';
